"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CheckOutline = _interopRequireDefault(require("@rsuite/icon-font/lib/action/CheckOutline"));

// Generated by script, don't edit it please.
var CheckOutline = (0, _createSvgIcon["default"])({
  as: _CheckOutline["default"],
  ariaLabel: 'check outline',
  category: 'action',
  displayName: 'CheckOutline'
});
var _default = CheckOutline;
exports["default"] = _default;
module.exports = exports.default;